import React from 'react'

const SecExtra = () => {
  return (
    <>
      <div className="relative text-center py-16 px-10 bg-[#f1f5f8] backdrop-blur-xl">
        <p className="relative text-3xl font-medium text-[#364655]">
          Looking for a hassle-free solution for your GST compliance needs?
        </p>
        <p className="relative text-3xl font-medium text-[#364655] mb-10">
          Inquire with EasyGST today and simplify your workflow !
        </p>
        <div>
          <a
            href="https://www.easyofficesoftware.com/public/demo/demo/EasyGSTDemoSetup.exe"
            rel="noreferrer"
            target="_blank"
            className="ml-5 sm:py-4 py-2 px-7 sm:px-20 rounded-lg bg-[#7decc6] text-black text-3xl font-bold shadow duration-150 hover:text-white hover:bg-[#51a589]"
          >
            Download Demo
          </a>
        </div>
      </div>
    </>
  );
}

export default SecExtra